import React from 'react'
import Layout from '../components/layout/Layout'

import { SEO } from 'gatsby-theme-seo'
import Img from 'gatsby-image'
import DecryptTitle from '../components/decryptTitle'
import TrelloLogo from '../svg/trello-logo-blue'

import { BLOCKS, MARKS } from "@contentful/rich-text-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

const TrelloBoardsOld = () => {
  return (
    <div className="flex flex-wrap justify-around mt-6">
      <div className="w-full md:w-1/2 lg:w-1/3">
        <iframe src="https://trello.com/embed/board?id=5b9c50cc685c6631407165f6&amp;targetOrigin=https://www.criptografiaedireito.org.br" className="trello-board trello-board-rendered trello-board-compact overflow-hidden w-64 h-56 mx-auto" ></iframe>
      </div>
      <div className="w-full md:w-1/2 lg:w-1/3">
        <iframe src="https://trello.com/embed/board?id=5b9c52784d3ca278f13f840f&amp;targetOrigin=https://www.criptografiaedireito.org.br" className="trello-board trello-board-rendered trello-board-compact overflow-hidden w-64 h-56 mx-auto" ></iframe>
      </div>
      <div className="w-full md:w-1/2 lg:w-1/3">
        <iframe src="https://trello.com/embed/board?id=5da232b8dddc4a3f0ff7f6b6&amp;targetOrigin=https://www.criptografiaedireito.org.br" className="trello-board trello-board-rendered trello-board-compact overflow-hidden w-64 h-56 mx-auto" ></iframe>
      </div>
      <div className="w-full md:w-1/2 lg:w-1/3">
        <iframe src="https://trello.com/embed/board?id=5da23229553cff2234f76307&amp;targetOrigin=https://www.criptografiaedireito.org.br" className="trello-board trello-board-rendered trello-board-compact overflow-hidden w-64 h-56 mx-auto" ></iframe>
      </div>
      <div className="w-full md:w-1/2 lg:w-1/3">
        <iframe src="https://trello.com/embed/board?id=5dc1838de3f40f21a1a80cad&amp;targetOrigin=https://www.criptografiaedireito.org.br" className="trello-board trello-board-rendered trello-board-compact overflow-hidden w-64 h-56 mx-auto" ></iframe>
      </div>
      <div className="w-full md:w-1/2 lg:w-1/3">
        <iframe src="https://trello.com/embed/board?id=5dc180317b3814479f75a6cc&amp;targetOrigin=https://www.criptografiaedireito.org.br" className="trello-board trello-board-rendered trello-board-compact overflow-hidden w-64 h-56 mx-auto" ></iframe>
      </div>
    </div>
  )
}

const TrelloBoardsNew = ({ 
  data: {
    imageSharp, 
    allTrelloBoard
  }, className 
}) => {
  const { edges } = allTrelloBoard
  const { fluid } = imageSharp
  return (
    <div className={`flex flex-wrap justify-around lg:w-full mx-auto ${className}`}>
        {edges.map (({ node }) => {
          const { name, id, shortUrl } = node
          return (
            <div id="trello_board" className="w-full md:w-1/2 lg:w-1/6 px-2 pb-4" >
              <a id={id} className="w-full h-auto block border-1 hover:border-criptoOrange-500 rounded-lg" href={shortUrl}>
                <div className="w-full pb-1/8 relative">
                  <Img fluid={fluid} id="board_bkg" className="w-full absolute top-0 left-0 rounded-lg" />
                  <div className="absolute top-0 left-0 w-full h-full">
                    <h3 className="text-left text-sm font-sans bg-white inline-flex box-border mt-2 ml-2 pb-2 pl- rounded-br-lg w-94/100 tracking-normal font-semibold">{name}</h3>
                    <div id="cards" className="flex flex-row w-full h-full justify-around px-2">
                      <div className="border-gray-300 bg-white border-2 border-t-8 rounded mr-2 w-1/4 shadow-md -24 h-58/100 md:h-42/100"></div>
                      <div className="border-gray-300 bg-white border-2 border-t-8 rounded mr-2 w-1/4 shadow-md -16 h-32/100 md:h-28/100"></div>
                      <div className="border-gray-300 bg-white border-2 border-t-8 rounded mr-2 w-1/4 shadow-md -30 h-42/100 md:h-34/100"></div>
                      <div className="border-gray-300 bg-white border-2 border-t-8 rounded mr-2 w-1/4 shadow-md -12 h-24/100 md:h-22/100"></div>
                    </div>
                  </div>
                  <div className="bg-gray-200 block w-full h-8 py-2 px-2 rounded-b-lg absolute bottom-0 left-0">
                    <TrelloLogo id="trello_brand" className="h-full pr-1/3 fill-current text-gray-600" />
                  </div>
                </div>
              </a>
            </div>
          )
        })}
    </div>
  )
}

const Acompanhamento = ({
  data
}) =>{
  const { contentfulPaginas } = data
  const { body } = contentfulPaginas

  return (
    <Layout id="Acompanhamento" additionalClassName="md:h-screen" contentAlignment="center">
      <SEO title="Acompanhamento no judiciário" />
      <div className="">
        <DecryptTitle data={data} spaceAfter={3} className="text-4xl lg:text-5xl xl:text-6xl font-bold leading-snug" />
        <div className="flex flex-col sm:flex-row sm:-mx-3 mt-2">
          <div className="flex-1 px-3 text-justify">
            {documentToReactComponents(body.json, {
              renderMark: {
                [MARKS.BOLD]: text => <span className="font-bold">{text}</span>,
                [MARKS.ITALIC]: text => <span className="italic]">{text}</span>,
                [MARKS.UNDERLINE]: text => <span className="underline">{text}</span>,
                [MARKS.CODE]: text => <span className="font-mono tracking-wider">{text}</span>,
              },
              renderNode: {
                [BLOCKS.HEADING_1]: (_node, children) => (
                  <h1>{children}</h1>
                ),
                [BLOCKS.HEADING_2]: (_node, children) => (
                  <h2>{children}</h2>
                ),
                [BLOCKS.HEADING31]: (_node, children) => (
                  <h3>{children}</h3>
                ),
                [BLOCKS.HEADING_4]: (_node, children) => (
                  <h4>{children}</h4>
                ),
                [BLOCKS.HEADING_5]: (_node, children) => (
                  <h5>{children}</h5>
                ),
                [BLOCKS.HEADING_6]: (_node, children) => (
                  <h6>{children}</h6>
                ),
                [BLOCKS.PARAGRAPH]: (_node, children) => <p className="text-base lg:text-lg font-light my-3">{children}</p>,
                [BLOCKS.QUOTE]: (_node, children) => <blockquote>{children}</blockquote>,
              },
            })}
          </div>
        </div>
        <TrelloBoardsNew data={data} className=" mt-8"/>
      </div>
      
    </Layout>

  )
}

export default Acompanhamento

export const pageQuery = graphql`
  query {
    contentfulPaginas(
      slug: {
        eq: "acompanhamento"
      }
    ) {
      slug
      titulo
      decrypt
      tituloDecrypt {
        textoNormal
        textoDecrypt
        posicionamento
      }
      body {
        json
      }
    }
  allTrelloBoard(
    filter: {
      id: {
        in: [
          "5b9c50cc685c6631407165f6", 
          "5b9c52784d3ca278f13f840f",
          "5da23229553cff2234f76307",
          "5da232b8dddc4a3f0ff7f6b6",
          "5dc180317b3814479f75a6cc",
          "5dc1838de3f40f21a1a80cad",
        ]
      }
    }
  ) {
    edges {
      node {
        name
        id
        shortUrl
      }
    }
  }
  imageSharp(
    fluid: {
      originalName: {
        eq: "trello_card_bkg.jpg"
      }
    }
  ) {
      fluid(maxWidth: 1200, toFormat: PNG) {
        ...GatsbyImageSharpFluid
      }
    }
  }
`